import React from 'react'
import BrandPageGallery from "./BrandPageGallery";
import BrandPageList from "./BrandPageList";
import BrandPagePartnerInformation from "./BrandPagePartnerInformation";
import BrandPageMediaText from "./BrandPageMediaText";
import ViewToggle from '../../subcomponents/ViewToggle'
import BrandPageOffer from "./BrandPageOffer";

const BrandPage = props => {
    return (
        <ViewToggle isMobile={props.isMobile('web')}>
            <div className="brand-page border">
                <BrandPagePartnerInformation campaign={props.campaign} partnerLogo={props.partnerLogo} />
                <BrandPageOffer {...props} campaign={props.campaign} partnerLogo={props.partnerLogo} />
                <BrandPageList campaign={props.campaign}/>
                <BrandPageMediaText title={props.campaign.brandpage_subline_3}
                                    copy={props.campaign.brandpage_text_3} />
                <BrandPageGallery image={props.campaign.image_16_9}/>
                <BrandPageMediaText title={props.campaign.brandpage_subline_4}
                                    copy={props.campaign.brandpage_text_4} />
            </div>
        </ViewToggle>
    )
}

export default BrandPage



// WEBPACK FOOTER //
// ./src/components/ads/brandPage/BrandPage.js